export class MPAResourceSelector {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceSelectionMode",
            "baseName": "resourceSelectionMode",
            "type": "MPAResourceSelectionMode",
            "format": ""
        },
        {
            "name": "resourceInclusionOverride",
            "baseName": "resourceInclusionOverride",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "resourceExclusionOverride",
            "baseName": "resourceExclusionOverride",
            "type": "Array<string>",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return MPAResourceSelector.attributeTypeMap;
    }
    constructor() {
    }
}
